import React from 'react';
import PropTypes from 'prop-types';
import Modal from '@spothero/ui/modal';
import ModalContent from '@spothero/ui/modal-content';
import Button from '@spothero/ui/button';

const GDPRModal = ({onHidden, countryCode}) => {
    const location = countryCode
        ? `country code ${countryCode}`
        : 'your country';

    return (
        <Modal
            className="GDPRModal"
            onHidden={onHidden}
            closeOnShimClick={false}
            showClose={false}
            animateOnShow={false}
        >
            <ModalContent>
                <h3>SpotHero is not currently available in {location}.</h3>
                <p>
                    We don&apos;t have parking in your area, but we do have over
                    5,000 garages across the US and Canada if you&apos;re ever
                    in need of a spot!
                </p>
                <Button color="primary" onClick={onHidden}>
                    Continue Anyway
                </Button>
            </ModalContent>
        </Modal>
    );
};

GDPRModal.propTypes = {
    onHidden: PropTypes.func.isRequired,
    countryCode: PropTypes.string,
};

export default GDPRModal;
